<script lang="ts" setup>
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner.vue'
import type { BtnVariants } from '@/components/lib/GwBtn/gwBtnVariants'

export interface BtnProps {
  variant: BtnVariants
  icon?: string
  text?: string
  id?: string
  tabindex?: number

  active?: boolean
  disabled?: boolean
  loading?: boolean
  loadingVariant?: 'spinner' | 'overlay'
}

withDefaults(defineProps<BtnProps>(), {
  variant: 'btn_default',
  tabindex: -1,
  loadingVariant: 'overlay',
})
</script>

<template>
  <button
    :id
    :class="variant"
    :tabindex
    v-bind="{
      ...(loading || active || disabled
        ? { 'data-state': loading ? 'loading' : active ? 'active' : disabled ? 'disabled' : '' }
        : {}),
    }"
  >
    <i
      v-if="icon"
      class="mdi btn_icon"
      :class="icon"
    ></i>
    <slot
      name="default"
      :text="text"
      >{{ text }}</slot
    >

    <GwBox
      v-if="loading && loadingVariant === 'spinner'"
      :variant
      style="position: absolute; left: 0; top: 0; height: 100%; width: 100%; z-index: 5"
      class="pos-abs d-flex align-center justify-center w-100 loader_overlay"
    >
      <template #default>
        <LoaderSpinner
          style="--size: calc(var(--text-size) * 1.5); --clr-spinner: var(--text-clr)"
        />
      </template>
    </GwBox>
  </button>
</template>

<style lang="scss" scoped>
@import '@/components/lib/GwBtn/gwBtnVariants.scss';
</style>
